import type { Editor } from "@tiptap/core";
import { createContext, type ReactElement, type ReactNode } from "react";
import type { ActionContextValue, NodeValues } from "./hooks/types";
import useCurrentAction from "./hooks/useCurrentAction";
import useType from "./hooks/useType";

const ActionContext = createContext<ActionContextValue>({
	actions: [],
	marks: [],
	attrs: { level: null },
	selection: null,
});

abstract class ButtonStateService {
	static Provider({ children, editor }: { children: ReactNode; editor: Editor }): ReactElement {
		const value = useType(editor);

		return <ActionContext.Provider value={value}>{children}</ActionContext.Provider>;
	}

	static useCurrentAction(current: NodeValues) {
		return useCurrentAction(current);
	}
}

export default ButtonStateService;

export { ActionContext };
